import PropTypes from 'prop-types';

export const ApplicationSettingsFlagsPropTypes = PropTypes.shape({
  maintenanceFlag: PropTypes.string,
});
